export const adobeProductTracking = ({ pageName, products, events }) => {
  if (window.adobeAnalytics) {
    window.adobeAnalytics.t({
      pageName,
      products,
      ...(events && { events }),
    });
  }
};

export const adobeClickTracking = ({ prop13, prop14 }) => {
  if (window.adobeAnalytics) {
    setTimeout(() => {
      window.adobeAnalytics.tl(true, "o", "", {
        prop12: "Nationals TicketFinder",
        prop13,
        prop14,
      });
    }, 1500);
  }
};

export const adobePageNameTracking = (props) => {
  if (window.adobeAnalytics) {
    setTimeout(() => {
      window.adobeAnalytics.t(props);
    }, 2000);
  }
};

export const adobeGameClickTracking = ({
  prop13,
  prop14,
  eVar40,
  prop40,
  prop44,
}) => {
  if (window.adobeAnalytics) {
    // console.log({ prop13, prop14, eVar40, prop40, prop44 });
    setTimeout(() => {
      window.adobeAnalytics.tl(true, "o", "", {
        prop12: "Nationals TicketFinder",
        prop13,
        prop14,
        eVar40,
        prop40,
        prop44,
      });
    }, 1700);
  }
};
